import { createContext, useContext, useEffect, useState, useCallback } from 'react';

const RecentlyViewedContext = createContext(null);
const KEY = 'evermark-recently-viewed-v1';
const MAX = 8;

export function RecentlyViewedProvider({ children }) {
  const [slugs, setSlugs] = useState(() => {
    if (typeof window === 'undefined') return [];
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(slugs)); }, [slugs]);

  const track = useCallback((slug) => {
    if (!slug) return;
    setSlugs((prev) => [slug, ...prev.filter((s) => s !== slug)].slice(0, MAX));
  }, []);

  const clear = useCallback(() => setSlugs([]), []);

  return (
    <RecentlyViewedContext.Provider value={{ slugs, track, clear }}>
      {children}
    </RecentlyViewedContext.Provider>
  );
}

export const useRecentlyViewed = () => useContext(RecentlyViewedContext);
